import './style.scss';

import { BrowserRouter } from 'react-router-dom';
import HttpsRedirect from 'react-https-redirect';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';

import { createStore } from 'redux';
import rootReducer from 'store/reducers';

// import store from 'store/store';
import App from './App';

const store = createStore(rootReducer);

ReactDOM.render((
  <HttpsRedirect>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </HttpsRedirect>),
document.getElementById('root'));
